import {onVisible} from "../../scripts/Tools/visible-element-observer";
import {clickEvent, documentLoadEvent, fireClickEvent} from "../../webpack/modules/events";
import {ga4TrackSimpleEvent} from "../../webpack/modules/analytics";

documentLoadEvent(function() {
    onVisible(document.querySelectorAll(".widget-help"), async function () {
        let helpWidgetType = document.getElementById('help-widget-type');
        let widgetHelpImg = document.querySelector('.widget-help img.secondary');
        if (widgetHelpImg) {
            widgetHelpImg.classList.remove('d-none');
            widgetHelpImg.src = widgetHelpImg.dataset.tawkSrc;
            clickEvent('.widget-help', false, function() {
                let widget = document.querySelector('.widget-help');
                Tawk_API.toggle();
                ga4TrackSimpleEvent({
                    event: 'help_banner',
                    method: 'product_page',
                    content_type: widget ? widget.dataset.type : 'unknown'
                });
            });
        }
    }, 0.1);
});
